import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { iconRss } from 'src/app/general/variables';
import { ParametroService } from 'src/app/services/parametro.service';

@Component({
  selector: 'app-modal-seguimiento-pp',
  templateUrl: './modal-seguimiento-pp.component.html',
  styleUrls: ['./modal-seguimiento-pp.component.css']
})
export class ModalSeguimientoPpComponent implements OnInit {

  iconRss = iconRss;
  strDscEnlace = '';

  constructor(public dialogRef: MatDialogRef<ModalSeguimientoPpComponent>,
              protected parametroService: ParametroService,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {

    this.strDscEnlace = this.data.strDscLink;
  }

  _aceptar() {

    this.dialogRef.close();

  }



}
